export enum QUALIFICATION_ANSWER_TYPE {
  YES = "Yes",
  NO = "No",
  ALREADY_ANSWERED = "AlreadyAnswered"
}

export interface AnswerQualificationQuestionResponse {
  result: QUALIFICATION_ANSWER_TYPE;
  redirectUrl: string;
  projectId: string;
}

export interface BiographyResponse {
  biography: string;
}

export interface ReferExpertPayload {
  email: string;
  firstName: string;
  lastName: string;
  designationTitle: string;
  endorsement?: string;
  linkedinUrl?: string;
}
